/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP1_ANSWERS = [
    'Holly and Harry are playing the piano together.',
    'Suddenly, Matt calls to Harry for help, and Stephanie calls to Holly for help.',
    'Matt is trying to fix the bicycle chain. But he has trouble with it.',
    'Matt couldn’t fix the chain. But Harry can fix it.',
    'Stephanie drops a glass and it rolls under the cabinet. She needs help getting it back.',
    'So, Holly reaches under, but she finds a rotten apple!',
    'Then, Holly reaches under again and picks up the glass.',
    'Stephanie sees Matt coming back from the garage. She tells him to do something about the rotten apple.',
    'So, Matt pretends to eat the rotten apple!',
    'Bethany calls Stephanie to say hi.',
    'Bethany asks about Holly and Harry. Stephanie says they are serious as always.',
    'Bethany wishes Tony could learn from Holly and Harry.',
    'However, Stephanie says Holly and Harry might learn from Tony!',
];

export const HHT1_EP1_ANSWER_SOUNDS = [
    '/bbb0d9eaaf8e71cc05c5577867e52f84.mp3',
    '/c203d63d265301c89aacb4f9de9024d1.mp3',
    '/6bf49e8121e8d54f22aaab8059499430.mp3',
    '/6c15f5a58bb0ae565989eb4a298002d5.mp3',
    '/d6bbbcbd41b579fa3f43ef8713d100fe.mp3',
    '/0a21abf2888688d8c3603cf052fbdf89.mp3',
    '/ca43d3626d551e7b8a4a8cca26f54e78.mp3',
    '/89b1a04da844da2008739ebe7696c3c7.mp3',
    '/a7d8e44b3b00b8fd987aedd1d1049225.mp3',
    '/5526cd09c7423fd84641d37bcca5e0d0.mp3',
    '/9357a0d2e149af02a4f2d5a982616ec3.mp3',
    '/335079d58d07fbc7feb9b7b4d92e1e26.mp3',
    '/8ee5a36fcb5cff4847fb388a8d205ed4.mp3',
];

export const HHT1_EP1_QUIZ_ITEMS = [{
    'A': HHT1_EP1_ANSWERS[1],
    'B': HHT1_EP1_ANSWERS[6],
    'SoundIndexA': 1,
    'SoundIndexB': 6,
    'answer': HHT1_EP1_ANSWERS[1],
    'sound': [2],
    'exception': false,
},
    {
        'A': HHT1_EP1_ANSWERS[9],
        'B': HHT1_EP1_ANSWERS[3],
        'SoundIndexA': 9,
        'SoundIndexB': 3,
        'answer': HHT1_EP1_ANSWERS[3],
        'sound': [4],
        'exception': false,
    },
    {
        'A': HHT1_EP1_ANSWERS[8],
        'B': HHT1_EP1_ANSWERS[5],
        'SoundIndexA': 8,
        'SoundIndexB': 5,
        'answer': HHT1_EP1_ANSWERS[5],
        'sound': [6, 7],
        'exception': false,
    },
    {
        'A': HHT1_EP1_ANSWERS[12],
        'B': HHT1_EP1_ANSWERS[8],
        'SoundIndexA': 12,
        'SoundIndexB': 8,
        'answer': HHT1_EP1_ANSWERS[8],
        'sound': [9, 10],
        'exception': true,
    },
    {
        'A': HHT1_EP1_ANSWERS[7],
        'B': HHT1_EP1_ANSWERS[11],
        'SoundIndexA': 7,
        'SoundIndexB': 11,
        'answer': HHT1_EP1_ANSWERS[11],
        'sound': [12],
        'exception': false,
    },

]
